import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { persistStore } from 'redux-persist';
import thunkMiddleware from 'redux-thunk';
import api from "./Api";
import Tracker from "@openreplay/tracker";
import trackerAssist from '@openreplay/tracker-assist';
import IsProduction from "../logic/IsProduction";
import trackerRedux from "@openreplay/tracker-redux";
import {isSupportTab} from "../logic/supportSession";

const isPrivateUrl = (url:string, method: string) => {
  if (url.includes('/extensions/available') && url.includes('/install') && method === 'POST') {
    return true;
  }
  if (url.includes('/extensions/installed/') && method === 'PUT') {
    return true;
  }
  return url.includes('/extensions/folios/') && method === 'PUT';
  
}

export const tracker = new Tracker({
  projectKey: window.config.openReplayKey ?? '',
  ingestPoint: window.config.openReplayUrl,
  obscureTextEmails: false,
  obscureInputEmails: false,
  defaultInputMode: 0,
  network: {
    failuresOnly: false,
    capturePayload: true,
    sessionTokenHeader: 'X-OpenReplay-Session',
    // x-session-key is a bearer credential like Authorization: punchout, embedded and support sessions all send it.
    ignoreHeaders: ['Authorization', 'Cookie', 'Set-Cookie', 'x-session-key'],
    captureInIframes: true,
    sanitizer: (data) => {
      if (data.url && isPrivateUrl(data.url, data.method)) {
        data.request.body = 'PRIVATE';
      }
      return data;
    }
  },
});

tracker.use(trackerAssist({}));

// Never in a support tab: the recording would carry the support session's key (in redux state and in the exchange
// response), and anyone with replay access could pick it up and use it until it expires.
if (IsProduction() && window.config.openReplayKey && window.config.openReplayUrl && !isSupportTab()) {
  tracker.start();
}

export const openReplayMiddleware = tracker.use(trackerRedux({}));

const store = configureStore({
  reducer: rootReducer,
  middleware: [api.middleware, thunkMiddleware, openReplayMiddleware],
});

const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;

export default {
  store,
  persistor,
};